import './FacilityRecordTabs.less'
import { Descriptions, Select, Spin } from 'antd'
import type { DescriptionsProps } from 'antd'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'

function FacilityRecordTabs() {
  const facilityStore = useStore('facilityStore')
  const [table1Items, setTable1Items] = useState<DescriptionsProps['items']>([])
  const [Loading, setLoading] = useState(false)
  const [resultShow, setResultShow] = useState(true)
  const select_Options = [
    { value: '최신순', label: '최신순' },
  ]

  useEffect(() => {
    setLoading(true)
    facilityStore.queryDlngList().then((res: any) => {
      if (res.code === 200) {
        const data = res.result
        if (data.length > 0) {
          const arr: DescriptionsProps['items'] = []
          data.forEach((item: any, index: number) => {
            arr.push(
              {
                key: index * data.length,
                label: '호실정보',
                children: item.numrNm,
                span: 4,
              },
              {
                key: index * data.length + 1,
                label: '거래일',
                children: item.dlngDt,
                span: 4,
              },
              {
                key: index * data.length + 2,
                label: '사용이력',
                children: item.hstryCn,
                span: 4,
              },
              {
                key: index * data.length + 3,
                label: '거래용도',
                children: item.prpCn,
                span: 4,
              },
            )
          })
          setTable1Items(arr)
          setLoading(false)
          setResultShow(true)
        }
        else {
          setLoading(false)
          setResultShow(false)
        }
      }
      else {
        setLoading(false)
        setResultShow(false)
      }
    })
  }, [facilityStore.FacilityInfoObj.idlFcltUnqNo])

  return (
        <div className={'FacilityRecordTabs'}>
          {
            resultShow
              ? (
                <Spin tip="검색..." size="large" spinning={Loading}>
                  <div className={'topBox'}>
                    <strong className={'result'}>거래이력</strong>
                    <Select
                        className={'Search-Results-Select'}
                        bordered={false}
                        options={select_Options}
                        defaultValue={select_Options[0].value}
                    />
                  </div>
                  <div className={'tablePart1'}>
                    <Descriptions size={'small'} bordered items={table1Items} />
                  </div>
                </Spin>
                )
              : (
                <div className={'not-info'}>
                    결과가 없습니다.
                </div>
                )
          }

        </div>
  )
}

export default observer(FacilityRecordTabs)
